import { render, staticRenderFns } from "./BufferSettings.vue?vue&type=template&id=492934e3&"
import script from "./BufferSettings.vue?vue&type=script&lang=js&"
export * from "./BufferSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports